import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-decb6d72")
const _hoisted_1 = { class: "templateDiv" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "templateTitle" }, "新建空白教案", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "templateTitle" }
const _hoisted_6 = { class: "pagination" }
_popScopeId()

import { PlusOutlined } from '@ant-design/icons-vue'
import { reactive, onBeforeMount, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getTeachPlanTemplateList } from '@/services/teach-plan-template'


export default {
  props: {
  node: {
    type: Object,
    default: () => null
  }
},
  emits: ['handleCreate', 'handleEdit'],
  setup(__props, { emit }) {

const props = __props
const router = useRouter()



// 获取创建课件的节点


const courseNode = computed(() => props.node)

const pageState = reactive({
  data: [],
  name: '',
  pagination: {
    total: 0,
    pageSize: 11,
    current: 1
  }
})

const handleCreate = () => {
  emit('handleCreate')
  if (courseNode.value) {
    router.push(`/resource/mine-coursewares/new/0/plan/0/${courseNode.value.id}`)
  } else {
    router.push('/resource/courseware/lessonPlan/edit/0/0/plan')
  }
}

const handleEdit = (templateItem) => {
  emit('handleEdit')
  if (courseNode.value) {
    router.push(`/resource/mine-coursewares/new/0/plan/${templateItem.id}/${courseNode.value.id}`)
  } else {
    router.push(`/resource/courseware/lessonPlan/edit/0/${templateItem.id}/plan`)
  }
}

const getCurrentPageData = async (page) => {
  pageState.pagination.current = page
  await getList({ page: pageState.pagination.current })
}

const getList = async (params) => {
  params = { page: 1, per_page: 11, ...params }
  const { items, pagination } = await getTeachPlanTemplateList(params)
  pageState.data = items
  const { total, pageSize } = pagination
  pageState.pagination.total = total
  pageState.pagination.pageSize = pageSize
}

onBeforeMount(async () => {
  await getList()
})

return (_ctx, _cache) => {
  const _component_a_pagination = _resolveComponent("a-pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "template create",
        onClick: handleCreate
      }, [
        (_unref(courseNode))
          ? (_openBlock(), _createBlock(_unref(PlusOutlined), {
              key: 0,
              style: {"color":"rgb(30, 195, 143)"}
            }))
          : (_openBlock(), _createBlock(_unref(PlusOutlined), { key: 1 })),
        _hoisted_2
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageState).data, (templateItem) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "template use",
          onClick: $event => (handleEdit(templateItem)),
          key: templateItem.id
        }, [
          _createElementVNode("div", {
            class: "templatePreview",
            innerHTML: templateItem.content
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, _toDisplayString(templateItem.name), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_a_pagination, {
        size: "small",
        "show-less-items": "",
        onChange: getCurrentPageData,
        current: _unref(pageState).pagination.current,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => (_unref(pageState).pagination.current = $event)),
        "page-size": _unref(pageState).pagination.pageSize,
        "onUpdate:page-size": _cache[1] || (_cache[1] = $event => (_unref(pageState).pagination.pageSize = $event)),
        total: _unref(pageState).pagination.total,
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "page-size", "total", "show-total"])
    ])
  ], 64))
}
}

}